export const isJsonUrl = (url: string) => {
  try {
    return url.endsWith('.json');
  } catch (e) {
    return false;
  }
};